<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>
<div class="bg-img-v4">
  <section class="container py-5">
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>

    <form
      class="custom-bg"
      [formGroup]="myForm"
      (ngSubmit)="onSubmit()"
      novalidate
    >
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <label
            style="font-weight: 600; margin-bottom: 0.3rem; color: white"
            >{{ "Data label" | translator }}</label
          >
          <span class="p-input-icon-right w-100">
            <input
              pInputText
              formControlName="name"
              class="w-100 ms-input-view"
              id="name"
              type="text"
            />
            <div
              class="error"
              *ngIf="
                myForm.controls['name'].invalid &&
                (myForm.controls['name'].dirty ||
                  myForm.controls['name'].touched)
              "
            >
              <div
                style="color: red; font-size: 12px"
                *ngIf="myForm.controls['name'].errors?.['required']"
              >
                {{ "The title is required" | translator }}
              </div>
            </div>
          </span>
        </div>
        <!-- Tree Data -->
        <div class="col-md-12 col-lg-6">
          <label
            style="font-weight: 600; margin-bottom: 0.3rem; color: white"
            >{{ "Organizational unit" | translator }}</label
          >
          <p-treeSelect
            (onNodeSelect)="reset()"
            class="w-md-20rem w-100"
            containerStyleClass="w-100"
            appendTo="body"
            formControlName="ou"
            [options]="selectedTreeData"
            placeholder="{{ 'Choose an organizational unit' | translator }}"
            [filter]="true"
            [filterInputAutoFocus]="true"
          >
            <ng-template let-node pTemplate="default">
              <div class="d-flex">
                <img
                  *ngIf="checkisImg(node.data); else elseBlock"
                  src="{{ staticURL }}{{ node.data }}"
                  class="img-fluid p-1 tree-img-bg"
                  style="max-height: 30px; max-width: 30px"
                />
                <ng-template #elseBlock>
                  <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                </ng-template>
                <b class="text-nowrap">{{ node.label }}</b>
              </div>
            </ng-template>
          </p-treeSelect>
        </div>

        <div class="col-md-12 col-lg-6">
          <label
            style="font-weight: 600; margin-bottom: 0.3rem; color: white"
            >{{ "Data type" | translator }}</label
          >
          <p-dropdown
            #typeID
            id="type"
            (onChange)="fetchTemplet(typeID.value)"
            [options]="dataType"
            [required]="true"
            [filter]="true"
            formControlName="type"
            placeholder="{{ 'Choose Type' | translator }}"
            styleClass=" sstarabic w-100"
          >
            <ng-template let-item pTemplate="item">
              <i [ngClass]="item.icon"></i>
              {{ item.label }}
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </form>
    <div [hidden]="fields.length <= 0" class="row custom-bg mx-1 my-4">
      <div
        *ngFor="let field of fields; let i = index"
        class="col-md-12 col-lg-6"
      >
        <label style="font-weight: 600; margin-bottom: 0.3rem; color: white">{{
          field.label
        }}</label>
        <div [ngSwitch]="selectedTemplete.fields[i].type.name">
          <!-- For text -->
          <div *ngSwitchCase="'text'">
            <span class="p-input-icon-right w-100">
              <i class="pi pi-clone"></i>
              <input
                pInputText
                [(ngModel)]="field.data"
                class="w-100 ms-input-view"
                [id]="field.label"
                type="text"
              />
            </span>
          </div>
          <!-- Rich text -->
          <div *ngSwitchCase="'Rich text'">
            <p-editor
              [(ngModel)]="field.data"
              [id]="field.label"
              [style]="{ height: '320px' }"
            ></p-editor>
          </div>
          <div *ngSwitchCase="'Upload Image'">
            <img
              [hidden]="field.data == ''"
              class="img-fluid"
              style="width: 100px"
              [src]="GlobalConstants.staticFilesURL + field.data"
            />
            <p-fileUpload
              mode="basic"
              chooseLabel="Choose"
              name="file"
              [url]="apilink + 'file/data'"
              [auto]="true"
              chooseLabel="Browse"
              accept="image/*"
              [maxFileSize]="1000000"
              (onUpload)="field.data = $event.originalEvent.body.data"
            ></p-fileUpload>
          </div>
          <div *ngSwitchCase="'Upload Document'">
            <a
              class="doc-view"
              [hidden]="field.data == ''"
              target="_blank"
              [href]="GlobalConstants.staticFilesURL + field.data"
            >
              <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i
              >{{ "Add a file" | translator }}
            </a>
            <p-fileUpload
              mode="basic"
              chooseLabel="Choose"
              name="file"
              [url]="apilink + 'file/data'"
              [auto]="true"
              chooseLabel="Add File"
              [maxFileSize]="100000000"
              (onUpload)="field.data = $event.originalEvent.body.data"
            ></p-fileUpload>
          </div>
          <div *ngSwitchCase="'Data Item'">
            <button
              type="submit"
              (click)="toggleModal(i)"
              pButton
              pRipple
              label="{{ 'addition' | translator }}"
              icon="pi pi-fw pi-plus-circle"
              class="w-full my-3"
            ></button>
            <p-dialog
              [blockScroll]="true"
              [draggable]="false"
              header="{{ 'Select a service' | translator }}"
              [(visible)]="modalVisibilities[i]"
              [style]="{ width: '95vw', maxWidth: '1700px' }"
            >
              <app-select-service
                (currentDataItem)="changeCurrentDataItem($event, field, i)"
              ></app-select-service>
            </p-dialog>
            <p class="font-bold" *ngIf="field.data">{{ field.data.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-center align-items-center"
      *ngIf="message"
    >
      <div style="color: red; font-size: 12px">{{ message | translator }}</div>
    </div>
    <div class="d-flex justify-content-center">
      <button
        type="submit"
        (click)="preview()"
        [disabled]="!myForm.valid"
        class="w-full my-3 v4-btn-every py-2"
      >
        <i class="pi pi-fw pi-database v4-ml-2"></i
        >{{ "addition" | translator }}
      </button>
    </div>
  </section>
</div>
<app-footer></app-footer>
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="Header"
  [(visible)]="previewModal"
  [style]="{ width: '95vw', maxWidth: '1000px' }"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Inspection" | translator }}</span>
  </ng-template>
  <div class="card-body ms-bg-left-custom">
    <h6 class="card-subtitle mb-2 v4-color-white">
      <i [class]="finalData?.type?.icon"></i> {{ finalData?.type?.label }}
    </h6>
    <h2 class="card-title v4-color-white" style="font-weight: 600">
      {{ finalData?.name }}
    </h2>
    <p-accordion class="w-full" [multiple]="true" [activeIndex]="0">
      <p-accordionTab
        *ngFor="let field of finalData?.fields; let i = index"
        iconPos="end"
        [selected]="i == 0 || i == 1"
      >
        <ng-template pTemplate="header">
          <div class="flex align-items-center">
            <i [ngClass]="getIcon(field?.type)" class="m-2"></i>
            <span class="vertical-align-middle m-2 v4-color-white">{{
              field?.label
            }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div [ngSwitch]="getFiledType(field?.type)">
            <!-- For text -->
            <div *ngSwitchCase="'text'">
              <span class="p-input-icon-right w-100">
                <div class="d-flex flex-column mb-0 datacontent">
                  {{ field.data }}
                </div>
              </span>
            </div>
            <!-- Rich text -->
            <div *ngSwitchCase="'Rich text'">
              <div
                class="d-flex flex-column mb-0 datacontent"
                [innerHTML]="field.data | safeHTML"
              ></div>
            </div>
            <div *ngSwitchCase="'Upload Image'">
              <img
                [hidden]="field.data == ''"
                class="img-fluid"
                style="width: 100px"
                [src]="GlobalConstants.staticFilesURL + field.data"
              />
            </div>
            <div *ngSwitchCase="'Upload Document'">
              <a
                class="doc-view"
                [hidden]="field.data == ''"
                target="_blank"
                [href]="GlobalConstants.staticFilesURL + field.data"
              >
                <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i
                >{{ "Add a file" | translator }}
              </a>
            </div>
            <div *ngSwitchCase="'Data Item'">
              <p-accordion class="w-full">
                <p-accordionTab
                  *ngFor="let fieldnew of field.data?.fields; let i = index"
                  iconPos="end"
                  [selected]="i == 0 || i == 1"
                >
                  <ng-template pTemplate="header">
                    <div class="flex align-items-center">
                      <i [ngClass]="fieldnew.field.icon" class="m-2"></i>
                      <span class="vertical-align-middle m-2">{{
                        fieldnew?.label.name
                      }}</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div [ngSwitch]="getFiledTypeLicenses(fieldnew.field.type)">
                      <!-- For text -->
                      <div *ngSwitchCase="'text'">
                        <span class="p-input-icon-right w-100">
                          <div class="d-flex flex-column mb-0 datacontent">
                            {{ fieldnew.data }}
                          </div>
                        </span>
                      </div>
                      <!-- Rich text -->
                      <div *ngSwitchCase="'Rich text'">
                        <div
                          class="d-flex flex-column mb-0 datacontent"
                          [innerHTML]="fieldnew.data | safeHTML"
                        ></div>
                      </div>
                      <div *ngSwitchCase="'Upload Image'">
                        <img
                          [hidden]="fieldnew.data == ''"
                          class="img-fluid"
                          style="width: 100px"
                          [src]="GlobalConstants.staticFilesURL + fieldnew.data"
                        />
                      </div>
                      <div *ngSwitchCase="'Upload Document'">
                        <a
                          class="doc-view"
                          [hidden]="fieldnew.data == ''"
                          target="_blank"
                          [href]="
                            GlobalConstants.staticFilesURL + fieldnew.data
                          "
                        >
                          <i
                            [hidden]="fieldnew.data == ''"
                            class="pi pi-file mx-2"
                          ></i
                          >{{ "Add a file" | translator }}
                        </a>
                      </div>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </ng-template>
      </p-accordionTab>
    </p-accordion>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      class="v4-btn"
      icon="pi pi-check"
      (click)="onSubmit(); previewModal = false"
      label="{{ 'OK' | translator }}"
      styleClass="p-button-text"
    ></p-button>
    <p-button
      class="v4-btn"
      icon="pi pi-times"
      (click)="previewModal = false"
      label="{{ 'Cancel' | translator }}"
      styleClass="p-button-text"
    ></p-button>
  </ng-template>
</p-dialog>
